import {blueColor, grayColor} from '../../cmsMainStyle'

const enhancedTableHeadStyle = theme => ({
    headerProperties: {
        fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
        fontWeight: "600",
        fontSize: "14px",
        color: grayColor[10],
        backgroundColor: blueColor[0]
    },

    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    }
})


export default enhancedTableHeadStyle